import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export type PatchDraftPayload = {
    projectName?: string;
    favicon?: File;
    content?: { html?: string; css?: string };
    documentHtml?: string;
    expectedPatchVersion?: number;
};

export const patchDraftAction = async (draftId: string, payload: PatchDraftPayload) => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const form = new FormData();

    if (payload.projectName) form.append("projectName", payload.projectName);
    if (payload.expectedPatchVersion != null)
        form.append("expectedPatchVersion", String(payload.expectedPatchVersion));

    if (payload.content) form.append("content", JSON.stringify(payload.content));
    if (payload.documentHtml) form.append("documentHtml", payload.documentHtml);

    if (payload.favicon) form.append("favicon", payload.favicon);

    const { data } = await gatewayPageBuilder.patch(
        `page-builder/drafts/${draftId}`,
        form,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return data.data;
};